<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <em v-if="isActive(tag)" class="tag-dot" />
        {{ tag.title }}
        <i
          v-if="!isAffix(tag)"
          class="el-icon-close tag-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </router-link>
    </scroll-pane>

    <div class="tags-view-actions">
      <el-tooltip content="定位当前标签" placement="bottom">
        <button type="button" class="tag-action-btn" @click="moveToCurrentTag">
          <i class="el-icon-location-outline" />
        </button>
      </el-tooltip>

      <el-popover
        v-model="tagPanelVisible"
        placement="bottom-end"
        width="320"
        popper-class="tags-panel-popper"
        trigger="click"
      >
        <div class="tags-panel">
          <div class="tags-panel-head">
            <div>
              <div class="tags-panel-title">打开的页面</div>
              <div class="tags-panel-sub">{{ visitedViews.length }} 个标签</div>
            </div>
            <button
              type="button"
              class="tags-panel-link danger"
              :disabled="!hasClosableTags"
              @click="closeAllFromToolbar"
            >
              全部关闭
            </button>
          </div>

          <div class="tags-panel-list">
            <div
              v-for="tag in visitedViews"
              :key="tag.path"
              class="tags-panel-item"
              :class="{ active: isActive(tag) }"
              @click="switchToTag(tag)"
            >
              <span class="tags-panel-dot" />
              <span class="tags-panel-name">{{ tag.title }}</span>
              <i
                v-if="!isAffix(tag)"
                class="el-icon-close tags-panel-close"
                @click.stop="closeSelectedTag(tag)"
              />
            </div>
          </div>

          <div class="tags-panel-footer">
            <button type="button" class="tags-panel-btn" @click="closeOthersFromToolbar">
              关闭其他
            </button>
            <button
              type="button"
              class="tags-panel-btn danger"
              :disabled="!hasClosableTags"
              @click="closeAllFromToolbar"
            >
              一键关闭
            </button>
          </div>
        </div>
        <button slot="reference" type="button" class="tag-action-btn tag-action-btn--wide">
          <i class="el-icon-menu" />
          <span>{{ visitedViews.length }}</span>
        </button>
      </el-popover>

      <el-tooltip content="一键关闭全部标签" placement="bottom">
        <button
          type="button"
          class="tag-action-btn tag-action-btn--danger"
          :disabled="!hasClosableTags"
          @click="closeAllFromToolbar"
        >
          <i class="el-icon-delete" />
        </button>
      </el-tooltip>
    </div>

    <transition name="ctx-fade">
      <ul
        v-show="visible"
        :style="{ left: left + 'px', top: top + 'px' }"
        class="contextmenu"
      >
        <li class="ctx-item" @click="refreshSelectedTag(selectedTag)">
          <i class="el-icon-refresh-right" /><span>刷新页面</span>
        </li>
        <li v-if="!isAffix(selectedTag)" class="ctx-item" @click="closeSelectedTag(selectedTag)">
          <i class="el-icon-close" /><span>关闭当前</span>
        </li>
        <li class="ctx-item" @click="closeOthersTags">
          <i class="el-icon-minus" /><span>关闭其他</span>
        </li>
        <div class="ctx-divider" />
        <li class="ctx-item ctx-item--danger" @click="closeAllTags(selectedTag)">
          <i class="el-icon-delete" /><span>全部关闭</span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'
import path from 'path'

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      tagPanelVisible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    },
    hasClosableTags() {
      return this.visitedViews.some(tag => !this.isAffix(tag))
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name, params } = this.$route
      if (name && params.tagview !== false) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags?.length) return
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.tagPanelVisible = false
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({ path: '/redirect' + fullPath })
        })
      })
    },
    closeSelectedTag(view) {
      this.tagPanelVisible = false
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.tagPanelVisible = false
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.tagPanelVisible = false
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    switchToTag(tag) {
      this.tagPanelVisible = false
      this.$router.push({ path: tag.path, query: tag.query, fullPath: tag.fullPath })
    },
    closeOthersFromToolbar() {
      const currentTag = this.$route
      this.tagPanelVisible = false
      this.$store.dispatch('tagsView/delOthersViews', currentTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllFromToolbar() {
      const currentTag = this.$route
      this.tagPanelVisible = false
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === currentTag.path)) {
          return
        }
        this.toLastView(visitedViews, currentTag)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        if (view.name === 'Dashboard') {
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 140
      const offsetLeft   = this.$el.getBoundingClientRect().left
      const offsetWidth  = this.$el.offsetWidth
      const maxLeft      = offsetWidth - menuMinWidth
      const left         = e.clientX - offsetLeft + 8

      this.left = left > maxLeft ? maxLeft : left
      this.top  = e.clientY - this.$el.getBoundingClientRect().top
      this.visible    = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
/* ── 配色变量 ────────────────────────────────────── */
$primary:           #409eff;
$primary-light:     #ecf5ff;
$primary-border:    #b3d8ff;
$bg-light:          #f5f7fa;
$text-regular:      #606266;
$text-secondary:    #909399;
$text-placeholder:  #c0c4cc;
$border-base:       #dcdfe6;
$border-light:      #e4e7ed;
$error-color:       #f56c6c;
$error-bg:          #fef0f0;

.tags-view-container {
  position: relative;
  height: 42px;
  width: 100%;
  background: linear-gradient(180deg, #fff 0%, #fbfcff 100%);
  border-bottom: 0.5px solid $border-light;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.03);
}

.tags-view-wrapper {
  height: 100%;
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.tags-view-item {
  display:     inline-flex;
  align-items: center;
  gap:         5px;
  position:    relative;
  cursor:      pointer;
  max-width:   168px;
  height:      28px;
  padding:     0 9px;
  font-size:   12px;
  margin-left: 6px;
  margin-top:  7px;
  border:        0.5px solid #e5e7eb;
  border-radius: 8px;
  color:        $text-regular;
  background:   #fff;
  white-space:    nowrap;
  user-select:    none;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-of-type { margin-left: 12px; }
  &:last-of-type  { margin-right: 12px; }

  &:hover:not(.active) {
    color:        $primary;
    background:   $primary-light;
    border-color: $primary-border;
  }

  &.active {
    background:   $primary;
    color:        #fff;
    border-color: $primary;
    box-shadow:   0 6px 16px rgba(64, 158, 255, 0.25);
    padding-left: 8px;

    .tag-close:hover {
      background: rgba(255, 255, 255, 0.28) !important;
      color:      #fff !important;
    }
  }
}

.tags-view-actions {
  flex-shrink: 0;
  height: 100%;
  padding: 0 10px 0 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(90deg, rgba(255,255,255,0.75), #fff 20%);
  border-left: 0.5px solid #eef2f7;
  box-shadow: -8px 0 14px rgba(255,255,255,0.92);
}

.tag-action-btn {
  height: 28px;
  min-width: 30px;
  padding: 0 8px;
  border: 0.5px solid #e5e7eb;
  border-radius: 8px;
  color: #64748b;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);

  &:hover:not(:disabled) {
    color: #2563eb;
    border-color: #bfdbfe;
    background: #eff6ff;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

.tag-action-btn--wide {
  min-width: 46px;
  font-weight: 600;
}

.tag-action-btn--danger:hover:not(:disabled) {
  color: #ef4444;
  border-color: #fecaca;
  background: #fef2f2;
}

.tag-dot {
  display:      inline-block;
  width:        6px;
  height:       6px;
  border-radius: 50%;
  background:   rgba(255, 255, 255, 0.9);
  flex-shrink:  0;
  font-style:   normal;
  animation:    tag-pulse 2s ease-in-out infinite;
}

.tag-close {
  display:         inline-flex;
  align-items:     center;
  justify-content: center;
  width:           14px;
  height:          14px;
  border-radius:   50%;
  font-size:       10px;
  flex-shrink:     0;
  transition:      all 0.18s ease;

  &:hover {
    background: $text-placeholder;
    color:      #fff;
  }
}

.tags-panel {
  padding: 4px;
}

.tags-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 8px 10px;
  border-bottom: 0.5px solid #eef2f7;
}

.tags-panel-title {
  font-size: 13px;
  color: #0f172a;
  font-weight: 700;
}

.tags-panel-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #94a3b8;
}

.tags-panel-link {
  border: 0;
  background: transparent;
  color: #2563eb;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;

  &:hover:not(:disabled) {
    background: #eff6ff;
  }

  &.danger {
    color: #ef4444;
    &:hover:not(:disabled) { background: #fef2f2; }
  }

  &:disabled {
    color: #cbd5e1;
    cursor: not-allowed;
  }
}

.tags-panel-list {
  max-height: 320px;
  overflow-y: auto;
  padding: 6px 2px;
}

.tags-panel-item {
  height: 34px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
  border-radius: 8px;
  cursor: pointer;
  color: #475569;
  transition: all 0.15s;

  &:hover {
    background: #f8fafc;
    color: #2563eb;
  }

  &.active {
    background: #eff6ff;
    color: #2563eb;
    font-weight: 600;
  }
}

.tags-panel-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
}

.tags-panel-item.active .tags-panel-dot {
  background: #2563eb;
}

.tags-panel-name {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.tags-panel-close {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #94a3b8;
  flex-shrink: 0;

  &:hover {
    background: #e2e8f0;
    color: #334155;
  }
}

.tags-panel-footer {
  display: flex;
  gap: 8px;
  padding: 10px 8px 6px;
  border-top: 0.5px solid #eef2f7;
}

.tags-panel-btn {
  flex: 1;
  height: 30px;
  border: 0.5px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  font-size: 12px;

  &:hover:not(:disabled) {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
  }

  &.danger:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #fecaca;
    color: #ef4444;
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

/* ── 右键菜单 ─────────────────────────────────────── */
.contextmenu {
  position:   absolute;
  z-index:    3000;
  margin:     0;
  padding:    4px;
  list-style: none;
  background: #fff;
  border: 0.5px solid $border-light;
  border-radius: 8px;
  min-width:  140px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .ctx-item {
    display:       flex;
    align-items:   center;
    gap:           8px;
    padding:       0 12px;
    height:        34px;
    border-radius: 5px;
    cursor:        pointer;
    font-size:     13px;
    color:         $text-regular;
    transition:    all 0.15s;

    i {
      font-size:   13px;
      color:       $text-secondary;
      width:       14px;
      text-align:  center;
      flex-shrink: 0;
      transition:  color 0.15s;
    }

    &:hover {
      background: $primary-light;
      color:      $primary;
      i { color: $primary; }
    }

    &--danger {
      color: $error-color;
      i     { color: $error-color; }

      &:hover {
        background: $error-bg;
        color:      $error-color;
        i { color: $error-color; }
      }
    }
  }

  .ctx-divider {
    height:     0.5px;
    background: $border-light;
    margin:     4px 8px;
  }
}

@keyframes tag-pulse {
  0%, 100% { opacity: 1;    transform: scale(1); }
  50%       { opacity: 0.55; transform: scale(0.72); }
}

.ctx-fade-enter-active {
  animation: ctx-in 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.ctx-fade-leave-active {
  animation: ctx-in 0.12s ease reverse;
}
@keyframes ctx-in {
  from { opacity: 0; transform: scale(0.86) translateY(-6px); }
  to   { opacity: 1; transform: scale(1)    translateY(0); }
}
</style>

<style lang="scss">
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width:          14px;
      height:         14px;
      border-radius:  50%;
      text-align:     center;
      vertical-align: -1px;
      transition:     all 0.22s cubic-bezier(.645,.045,.355,1);
      transform-origin: center;

      &::before {
        display:        inline-block;
        transform:      scale(0.75);
        vertical-align: -2px;
      }

      &:hover {
        background-color: #c0c4cc;
        color:            #fff;
      }
    }
  }
}

.tags-panel-popper {
  padding: 6px !important;
  border-radius: 12px !important;
  border: 0.5px solid #e5e7eb !important;
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.14) !important;
}
</style>
